import PropTypes from 'prop-types';
import { __ } from '@web-stories-wp/i18n';
import {
  Button,
  BUTTON_SIZES,
  BUTTON_TYPES,
  BUTTON_VARIANTS,
} from '@web-stories-wp/design-system';
import Tooltip from '../../../tooltip';
import { ReactComponent as CropIcon } from './textureCrop.svg';
import { useCanvas } from '../../../../app';

export default function TextureTransformControls({
  selectedElements,
  disabled,
}) {
  const { setEditingElementWithState } = useCanvas(({ actions }) => actions);
  const element = selectedElements.length === 1 ? selectedElements[0] : null;
  const label = __('Scale & Crop Texture', 'web-stories');
  return (
    <Tooltip hasTail title={label}>
      <Button
        aria-label={label}
        variant={BUTTON_VARIANTS.SQUARE}
        size={BUTTON_SIZES.SMALL}
        type={BUTTON_TYPES.TERTIARY}
        disabled={disabled || !element?.textTexture?.src || element.isLocked}
        onClick={() =>
          setEditingElementWithState(element.id, {
            texture: true,
            showOverflow: true,
          })
        }
      >
        <CropIcon aria-hidden="true" focusable="false" />
      </Button>
    </Tooltip>
  );
}
TextureTransformControls.propTypes = {
  selectedElements: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
};
